// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import React from "react";
import MaskedInput from "../MaskedInput";

function CepInput(props) {
  return (
    <MaskedInput
      mask="99999-999"
      label="CEP"
      placeholder="00000-000"
      inputProps={{ inputMode: "decimal" }}
      autoComplete="postal-code"
      {...props}
    />
  );
}

export default CepInput;
